// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { getApplication } from "./application"

const application = getApplication()

import AccordionController from "./accordion_controller.js"
import ApplicationController from "./application_controller"
import AudioPlayerController from "./audio_player_controller"
import CartController from "./cart_controller"
import CustomizeController from "./customize_controller.js"
import CustomRequestController from "./custom_request_controller"
import DrawerController from "./drawer_controller"
import DropdownController from "./dropdown_controller.js"
import HeaderController from "./header_controller.js"
import MixtapesController from "./mixtapes_controller"
import ModalController from "./modal_controller.js"
import NavigationController from "./navigation_controller"
import NewsletterController from "./newsletter_controller"
import FooterController from "./footer_controller.js"
import ProjectSearchesController from "./project_searches_controller"
import RemovalsController from "./removals_controller.js"

console.log("registering stimulus controllers")

application.register("application", ApplicationController)
application.register("audio-player", AudioPlayerController)
application.register("cart", CartController)
application.register("drawer", DrawerController)
application.register("mixtapes", MixtapesController)
application.register("searches", ProjectSearchesController)
application.register("navigation", NavigationController)
application.register("removals", RemovalsController)
application.register("customize", CustomizeController)
application.register("custom-request", CustomRequestController)
application.register("modal", ModalController)
application.register("accordion", AccordionController)
application.register("dropdown", DropdownController)
application.register("header", HeaderController)
application.register("newsletter", NewsletterController)
application.register("footer", FooterController)